module.exports = __webpack_public_path__ + "static/img/k_ch.d576268e.png";